export const title = "About me";
export const text =
  "I'm Joel Taylor, a young front-end web developer with 3 years of experience. My expertise includes React JS, Tailwind CSS, Firebase, and a range of languages like HTML, CSS, JavaScript, Python, Java, and C#. I've also completed numerous projects on Fiverr.";
